<div class="order-address-container">
    <div class="icon-wrapper">
        <cwo-icon [name]="iconName()" class="icon"/>
    </div>
    <div class="info-wrapper">
        <span class="address-name">{{address()?.name}}</span>
        <div class="address-info-wrapper">
            <span class="address-info">{{addressInfo()}}</span>
        </div>
        <button class="button-accent button-save" (click)="!savedTempAddress ? saveToAddressBook() : null">
            @if(savedTempAddress){
                <cwo-icon class="icon" [name]="iconNameType.check" style="min-width: 0.7rem;"></cwo-icon>
            }
            {{savedTempAddress ? 'Saved' : 'Save to Address Book'}}
        </button>
    </div>
    <div class="edit-container">
        <button class="button-undecorated button-edit" (click)="editOrderAddress()" [ariaLabel]="'Edit order address'">
            <cwo-icon [name]="iconNameType.edit" class="icon"/>
        </button>
    </div>
</div>